export const parseDateToReadableString = (date: Date) => {
	const day = date.getDate();
	const month = new Intl.DateTimeFormat("en", { month: "long" }).format(date);
	const year = date.getFullYear();

	const formattedDate = `${day}${getOrdinalSuffix(day)} of ${month} ${year}`;

	return formattedDate;
};
export const parseDateToNumberDate = (date: Date) => {
	const year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
	const month = new Intl.DateTimeFormat("en", { month: "numeric" }).format(date);
	const day = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
	const str = date.toLocaleTimeString("en-uk").split(":");
	str.pop();
	return `${day}/${month}/${year} ${str.join(":")}`;
};
const getOrdinalSuffix = (day: number) => {
	if (day >= 11 && day <= 13) {
		return "th";
	}

	const lastDigit = day % 10;
	switch (lastDigit) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
};

export function daysUntilNextMonth() {
	const curDate = new Date();
	const daysInMonthN = daysInMonth(curDate.getMonth(), curDate.getFullYear());
	return daysInMonthN - curDate.getDate();
}

export function daysInMonth(month: number, year: number) {
	return new Date(year, month, 0).getDate();
}
/**
 *
 * @description used to parse iso 8601 date format
 * @param dateString
 * @returns
 */
export function getTimeUntilNewGenerations(dateString: string): string {
	// Parse the input date string to create a Date object
	const date = new Date(dateString);

	// Get the current date and time
	const now = new Date();

	// Calculate the time difference in milliseconds
	const timeDifference: number = date.getTime() - now.getTime();

	// Calculate days and hours
	const daysDifference: number = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
	const hoursDifference: number = Math.floor(
		(timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
	);

	// Determine the appropriate text based on the difference
	if (daysDifference >= 1) {
		return `Days until new generations: ${daysDifference}d`;
	}
	return `Hours until new generations: ${hoursDifference}h`;
}
/**
 *
 * @param durations in second
 * @description format seconds number to readeble string
 * @example sFromat(10) //ten seconds
 * @returns
 */
export function sFormat(durations: number) {
	// minutes and seconds
	const mins = Math.floor(durations / 60);
	const secs = ~~durations % 60;

	// Output like "1:01" or "1:10" or 1
	let ret = "";
	if (mins) {
		ret += `${mins}:${secs < 10 ? "0" : ""}`;
	}
	ret += `${secs}`;

	return ret;
}
/**
 * @description used for converting input date to fastapi date
 */
export const formatStringDateToQueryDate = (date: string) => {
	// Convert the input date string to a Date object
	const dateObj = new Date(date);

	// Format year, month, and day
	const year = dateObj.getFullYear();
	// getMonth() returns 0-11; adding 1 to align with natural counting and padStart to ensure two digits
	const month = String(dateObj.getMonth() + 1).padStart(2, "0");
	const day = String(dateObj.getDate()).padStart(2, "0");

	// Since no time is specified, default to "00:00:00"
	const time = "00:00:00";

	// Combine the formatted parts into the final date-time string
	return `${year}-${month}-${day} ${time}`;
};
